import React, { useEffect, useRef } from 'react'
import { CBTooltip } from '@cb/apricot'
import styled from 'styled-components'

interface TooltipProps {
  placement?: 'top' | 'right' | 'bottom' | 'left'
  light?: boolean
  textContent: string
}
interface StyledInfoTooltipProps {
  size: string
}

const StyledInfoTooltip = styled.span<StyledInfoTooltipProps>`
  display: flex;
  font-size: 0.765rem;
  vertical-align: middle;
  svg:hover {
    fill: #0077c8 !important;
  }
`

export const InfoTooltip: React.FC<TooltipProps> = ({
  textContent = 'placeholder',
  placement = 'top',
  light = false,
}) => {
  const ref = useRef()

  useEffect(() => {
    const tooltip = CBTooltip({
      markup: false,
      elem: ref.current,
      placement,
      title: textContent,
      style: light && 'cb-tooltip-light',
    })

    const hideTooltip = ({ key }) => {
      if (key === 'Escape') {
        tooltip.hide()
      }
    }

    window.addEventListener('keydown', hideTooltip)
    return () => {
      window.removeEventListener('keydown', hideTooltip)
    }
  })
  return (
    <>
      <StyledInfoTooltip ref={ref} role="link" tabIndex={0} aria-label="tooltip">
        <svg
          role="img"
          aria-hidden="true"
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          fill="#828385"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
          />
        </svg>
      </StyledInfoTooltip>
      <div role="tooltip" className="cb-tooltip hidden" aria-hidden="true">
        <div className="cb-tooltip-inner"></div>
      </div>
    </>
  )
}
